import React from 'react';
import Tooltip from '../../../../CoreWrappers/Tooltip';
import OutputText from '@ey/canvascoreservices/OutputText';
import Checkbox from '../../../../CoreWrappers/Checkbox';
import LoadingWrapper from '../../../../CoreWrappers/LoadingWrapper';

const prop = 'Checkbox';

export const config = (labels, handleChange) => ({
	id: `${prop}Column`,
	propName: 'accountId',
	width: 'var(--px-60)',
	customCell: (item) => {
		const disable = item?.isDisabled;
		const selected = item?.isSelected;

		const renderCheckBox = () => {
			const props = {
				id: item.accountId,
				disabled: disable,
				checked: selected,
				hidetitletip: true,
				value: disable || selected,
				onChange: () => handleChange(item.accountId)
			};
			return <Checkbox {...props} />;
		};

		if (disable) {
			const renderTrigger = () => {
				return renderCheckBox();
			};

			const toolTipProps = {
				trigger: renderTrigger(),
				allowClick: true
			};

			return (
				<Tooltip {...toolTipProps}>
					<OutputText body2 light maxWidth="var(--px-700)" wordBreak={true}>
						{labels.relateAccountTableDisabledRowToolTip}
					</OutputText>
				</Tooltip>
			);
		}

		return (
			<LoadingWrapper isLoading={item?.isLoading} blockContent loaderSize="xs" spacing="none">
				{renderCheckBox()}
			</LoadingWrapper>
		);
	}
});
